import {
  BookableEntity,
  SDBookableAppointmentType,
} from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule_definitions.pb';
import { AvailabilityRuleEntity } from '../../hooks/use-get-availability-rules';

const normalizeText = (value: string) => value.toLowerCase().replace(/\s+/g, ' ').trim();

const getResourceNames = (bookableEntities: BookableEntity[] | undefined) =>
  (bookableEntities || []).map((entity) => entity.resourceDisplayName || '');

const getServiceNames = (bookableAppointmentTypes: SDBookableAppointmentType[] | undefined) =>
  (bookableAppointmentTypes || []).map((service) => service.name || '');

const getSearchableText = (availabilityRule: AvailabilityRuleEntity) => {
  const groupNames = [availabilityRule.displayName, availabilityRule.externalName];

  const definitionNames = availabilityRule.scheduleDefinitions.map((definition) => definition.displayName || '');

  const resourceNames = availabilityRule.scheduleDefinitions.flatMap((definition) =>
    getResourceNames(definition.bookableEntities)
  );

  const serviceNames = availabilityRule.scheduleDefinitions.flatMap((definition) =>
    getServiceNames(definition.bookableAppointmentTypes)
  );

  return normalizeText([...groupNames, ...definitionNames, ...resourceNames, ...serviceNames].join(' '));
};

export const matchesAvailabilityRuleSearch = (availabilityRule: AvailabilityRuleEntity, searchValue: string) => {
  const normalizedSearch = normalizeText(searchValue);

  if (!normalizedSearch) {
    return true;
  }

  const searchTokens = normalizedSearch.split(' ').filter(Boolean);

  if (!searchTokens.length) {
    return true;
  }

  const searchableText = getSearchableText(availabilityRule);

  return searchTokens.every((token) => searchableText.includes(token));
};
